import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-rodape',
    imports: [],
    templateUrl: './rodape.component.html',
    styleUrl: './rodape.component.scss'
})
export class RodapeComponent {

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  acessaTermos() {
    this.router.navigate(['/termos']);
  }
  acessaTrabalheConosco() {
    this.router.navigate(['/trabalhe-conosco']);
  }

  acessaSobreNos() {
    this.router.navigate(['/sobre']);
  }
}
